import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { makeStyles } from "@material-ui/core/styles";
import Timeline from "@material-ui/lab/Timeline";
import TimelineItem from "@material-ui/lab/TimelineItem";
import TimelineSeparator from "@material-ui/lab/TimelineSeparator";
import TimelineConnector from "@material-ui/lab/TimelineConnector";
import TimelineContent from "@material-ui/lab/TimelineContent";
import TimelineOppositeContent from "@material-ui/lab/TimelineOppositeContent";
import TimelineDot from "@material-ui/lab/TimelineDot";
import { Avatar } from "@material-ui/core";
import doctor from "../../assets/doctor.svg";
import clinician from "../../assets/clinician.svg";
import appointment from "../../assets/appointment.svg";
import send2Pass from "../../assets/send2Pass.svg";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(theme => ({
  paper: {
    padding: "6px 16px"
  },
  secondaryTail: {
    backgroundColor: theme.palette.secondary.main
  }
}));

const TimeLineItem = ({ date, time, icon, clinicianName, actionHeading, actionDesc }) => {
  const classes = useStyles();
  return (
    <>
      <Typography variant="body2" color="textSecondary" className="timeTitle">
        {date}
      </Typography>
      <TimelineItem>
        <TimelineSeparator>
          <TimelineConnector />
          <Typography variant="body2" color="textSecondary" className="timeText">
            {time}
          </Typography>
          <TimelineDot className="timelineImg">
            <Avatar className="timeLineAvatar" variant="square" src={icon} />
          </TimelineDot>
          <TimelineConnector className="connectorBottom" />
        </TimelineSeparator>
        <TimelineContent className="timelineInfo">
          <Row>
            <Col className="infoCol">
              <Avatar className="timeLineAvatar" alt="Remy Sharp" src={doctor} />
            </Col>
            <Col className="infoContent">
              <Typography className="timeLineHead"> {clinicianName} </Typography>
              {/* <Typography className="timeLineSubHead">APRN-CNP</Typography> */}
            </Col>
          </Row>
        </TimelineContent>
        <TimelineOppositeContent className="timelineContent">
          <Paper elevation={3} className={classes.paper} id="timeLinePaper">
            <Typography className="timeLineHead">{actionHeading}</Typography>
            <Typography className="timeLineSubHead">{actionDesc}</Typography>
          </Paper>
        </TimelineOppositeContent>
      </TimelineItem>
    </>
  );
};

const PatientHistory = props => {
  const [patientHistory, setPatientHistorys] = useState(props.patientHistory);

  return (
    <>
      <Row className="TimelineRow">
        <Col>
          <Timeline align="left">
            <TimeLineItem
              date="Today"
              time="9:45 AM"
              icon={clinician}
              clinicianName="Krishna Raj"
              actionHeading="Patient Re-Assigned"
              actionDesc="Patient assigned to Krishna Raj from Adrienne Ton"
            />
            <TimeLineItem
              date="Today"
              time="9:45 AM"
              icon={appointment}
              clinicianName="Krishna Raj"
              actionHeading="Patient Re-Assigned"
              actionDesc="Patient assigned to Krishna Raj from Adrienne Ton"
            />
          </Timeline>
        </Col>
      </Row>
    </>
  );
};

export default PatientHistory;
